module.exports = __webpack_public_path__ + "img/shield_selected_dark.9d61ea55.png";